import type { CheckoutProps } from "@hopper-b2b/types";
import { Actions } from "./actions";
import { PFCheckoutComponent } from "./components";
import { Guards } from "./guards";
import { getInitialPriceFreezeMachineContext } from "./initialContext";
import { Services } from "./services";
import { priceFreezePurchaseStateMachine } from "./stateMachine";

import {
  populateCheckoutQueryParams,
  transitionStateOnPathnameChange,
} from "./utilities";

const CHECKOUT_TITLE = "Price freeze";
const PORTAL_TITLE = "Uber | Hopper";

const onPriceFreezePurchaseLoad = () => {
  document.title = CHECKOUT_TITLE;
};

const onPriceFreezePurchaseOnCleanUp = () => {
  document.title = PORTAL_TITLE;
};

export const priceFreezePurchaseProps: CheckoutProps = {
  stateMachine: priceFreezePurchaseStateMachine,
  Component: PFCheckoutComponent,
  actions: Actions,
  context: getInitialPriceFreezeMachineContext(),
  guards: Guards,
  services: Services,
  onCleanUp: onPriceFreezePurchaseOnCleanUp,
  onLoad: onPriceFreezePurchaseLoad,
  getInitialContext: getInitialPriceFreezeMachineContext,
  onStateValueChange: populateCheckoutQueryParams,
  onPathnameChange: transitionStateOnPathnameChange,
};
